const merge = require('deepmerge');
const theme = require('./theme');

module.exports = function mergeThemes(uiTheme) {
    const result = merge(uiTheme, theme);
    return result;
};
